// removed by extract-text-webpack-plugin
module.exports = {"hidden":"zKkKd","visuallyhidden":"_1HmWk","hide-text":"_3POiJ","center":"MfQv_","noprint":"_3Iz2x","root":"_16Hff","caption":"_3c1zM","fullcaption":"_22Ma7","captionButton":"_1SWSu","image":"uBFNo"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-image/styles/Image.scss
 ** module id = 945
 ** module chunks = 1
 **/